import config, { EnvironmentEnum } from './index';

export const isProduction = () => {
  return config.ENVIRONMENT === EnvironmentEnum.PRODUCTION;
};

export const isStaging = () => {
  return config.ENVIRONMENT === EnvironmentEnum.STAGING;
};

export const isDevelopment = () => {
  return config.ENVIRONMENT === EnvironmentEnum.DEVELOPMENT;
};
